import type DropViewState from '../store/schema/DropViewState';
import { mutatorAction } from 'satcheljs';

// Set Drop state, should be called only from Droppable component
const setDropStateMutator: (
    viewState: DropViewState,
    isDragOver: boolean,
    draggableItemType: string | null
) => void = mutatorAction(
    'setDropState',
    function (
        viewState: DropViewState,
        isDragOver: boolean,
        draggableItemType: string | null
    ): void {
        viewState.isDragOver = isDragOver;
        viewState.draggableItemType = draggableItemType;
    }
);
export default setDropStateMutator;
